// import { createContext, useContext, useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';

// const ThemeContext = createContext();

// export const ThemeProvider = ({ children }) => {
//     const [theme, setTheme] = useState('light'); // 'light' or 'dark'

//     const toggleTheme = () => {
//         setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
//     };
//     console.log(location, 'location here');
//     useEffect(() => {
//         const root = document.documentElement;

//         if (theme === 'dark') {
//             root.classList.remove('light-mode');
//             root.classList.add('dark-mode');
//         } else {
//             root.classList.remove('dark-mode');
//             root.classList.add('light-mode');
//         }
//     }, [theme]);

//     return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
// };

// export const useTheme = () => {
//     const context = useContext(ThemeContext);
//     if (!context) {
//         throw new Error('useTheme must be used within a ThemeProvider');
//     }
//     return context;
// };

import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    useEffect(() => {
        const root = document.documentElement;

        const updateTheme = () => {
            const pathname = window.location.pathname;

            if (pathname.includes('greenpill')) {
                root.classList.remove('light-mode');
                root.classList.add('dark-mode');
            } else {
                root.classList.remove('dark-mode');
                root.classList.add('light-mode');
            }
        };

        updateTheme(); // Initial call

        const patchHistoryMethods = () => {
            if (typeof window !== 'undefined' && window.history) {
                const { pushState, replaceState } = window.history;

                window.history.pushState = function (...args) {
                    const result = pushState.apply(this, args);
                    window.dispatchEvent(new Event('locationchange'));
                    return result;
                };

                window.history.replaceState = function (...args) {
                    const result = replaceState.apply(this, args);
                    window.dispatchEvent(new Event('locationchange'));
                    return result;
                };
            }
        };

        patchHistoryMethods();

        window.addEventListener('popstate', updateTheme);
        window.addEventListener('locationchange', updateTheme);

        return () => {
            window.removeEventListener('popstate', updateTheme);
            window.removeEventListener('locationchange', updateTheme);
        };
    }, []);

    return <ThemeContext.Provider value={{}}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
